module.exports = __webpack_public_path__ + "static/media/Loading_icon.f4404720.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Loading_icon.gif
// module id = 972
// module chunks = 1